import type { Step } from "react-joyride";

export const zoneFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຟອມສ້າງ/ແກ້ໄຂໂຊນ. ຕື່ມລະຫັດ (VTE, NEAR, FAR), ຊື່ 3 ພາສາ ແລະ ລຳດັບ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="shipping-form-code"]',
    content: "ລະຫັດໂຊນ — ບໍ່ຊ້ຳກັນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-form-nameLo"]',
    content: "ຊື່ພາສາລາວ (ອາດເປີດວ່າງ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-form-sortOrder"]',
    content: "ລຳດັບສະແດງໂຊນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-form-submit"]',
    content:
      "ກົດ 'ບັນທຶກ' ເພື່ອບັນທຶກ ຫຼື 'ຍົກເລີກ' ເພື່ອກັບຄືນ.",
    placement: "top",
  },
];
